import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { DataService } from 'src/app/service/data.service';
import { DOCUMENT, CommonModule } from '@angular/common';
import { BadgeDictionary, badgeListInterface } from './badge-dictionary.component';
import { ButtonModule } from 'primeng/button';
import { Badge } from '../../../api/badge';

@Component({
  selector: 'app-badge-display',
  standalone: true,
  imports: [
    ButtonModule,
    CommonModule,
  ],
  templateUrl: './badge-display.component.html',
  styleUrl: './badge-display.component.scss'
})
export class BadgeDisplayComponent implements OnInit {

  private user = this.dataService.user();
  protected readerBadge: boolean = false;
  protected writerBadge: boolean = false;
  protected superheroBadge: boolean = false;
  //protected badgeDictionary: BadgeDictionary;
  //@ViewChild(BadgeDictionary) badgeDictionary: BadgeDictionary

  protected tempCheck: boolean = false;
  
  protected badge = Badge.BADGES;
  

  constructor(private dataService: DataService, @Inject(DOCUMENT) private document: Document, ) {

  }


   async ngOnInit() {
    this.roleBadgeActivation();
  }


  roleBadgeActivation() {
    if (this.user.writerProfile && this.user.betaReaderProfile) {
      this.superheroBadge = true;
      console.log("both roles")
    } else if (this.user.writerProfile) {
      this.writerBadge = true;
      console.log("writer")
    } else if (this.user.betaReaderProfile) {
      this.readerBadge = true;
      console.log("reader")
    }
  }

  protected badgeList: badgeListInterface[] = [
    { id: 0, badgeCode: "SCRV_BETA", imgUrl: "../../../assets/badges/beta_tester_badge.png", earnValue: false }
  ];





  


  async isBadgeEarned(badgeCode: string) {

    let result = await this.dataService.checkForBadge(badgeCode)

    console.log("this is a test");
    if (result == "NULL") {
      console.log("we got null")
      return false;
    } else if (result == "EARNED") {
      console.log("we got earned")
      return true;
    }

    return true;
  }

async earnBetaBadge() {
  await this.dataService.earnBadge("SCRV_BETA");
}


}

